import { Head, router } from "@inertiajs/react"

import { MainContainer } from "@/components/ui/container"
import { PageHeader } from "@/components/ui/headers"
import { StaffLayout } from "@/components/layouts/staff-layout"
import {
  ReservationBook,
  type Reservation,
  type TableOption,
} from "@/features/staff/loyalty/reservation-book"
import { t } from "@/lib/i18n"

/**
 * The book, one service at a time.
 *
 * The day is a server-resolved value in the RESTAURANT's zone and travels in the
 * URL, so a host can send "mira el sábado" as a link. A full visit rather than
 * client state: every row is server-computed, and there is nothing here the
 * browser could re-derive.
 */

type Props = {
  day: string
  reservations: Reservation[]
  tables: TableOption[]
  timeZone: string
  holdingCount: number
}

export default function StaffLocationReservationsIndex({
  day,
  reservations,
  tables,
  timeZone,
  holdingCount,
}: Props) {
  const title = t("ui.react.pages.staff.location.reservations.index.page_title")

  return (
    <>
      <Head title={title} />

      <MainContainer size="md">
        <PageHeader
          title={title}
          description={t("ui.react.pages.staff.location.reservations.index.page_description")}
        />

        <label className="flex w-48 flex-col gap-1">
          <span className="text-muted-foreground text-xs">
            {t("ui.react.pages.staff.location.reservations.index.day_label")}
          </span>
          <input
            type="date"
            className="border-input h-11 rounded-md border px-3 text-sm tabular-nums md:h-9"
            value={day}
            data-testid="reservation-day"
            onChange={(event) => router.get("/reservations", { day: event.target.value })}
          />
        </label>

        <ReservationBook
          reservations={reservations}
          tables={tables}
          timeZone={timeZone}
          holdingCount={holdingCount}
        />
      </MainContainer>
    </>
  )
}

StaffLocationReservationsIndex.layout = (page: React.ReactNode) => <StaffLayout>{page}</StaffLayout>
